import * as classnames from 'classnames'
import * as React from 'react'
import * as classNames from './Form.css'

export interface ITheme {
  error?: string
}

export interface IProps {
  className?: string
  onSubmit?: (event: React.SyntheticEvent<any>) => void
  error?: string
  children?: any
  theme?: ITheme
}

/**
 * `<form>` wrapper that adds display for redux-form entire-form errors (`_error` key in the error object).
 */
class Form extends React.PureComponent<IProps, {}> {
  public render() {
    const {className, onSubmit, error, theme = {}} = this.props
    const errorClassName = classnames(theme.error, classNames.error)
    return (
      <form className={className} onSubmit={onSubmit}>
        {error && <p className={errorClassName}>{error}</p>}
        {this.props.children}
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/form/Form.tsx